// SDK-owned header injection; anchored targets exclude unrelated third-party origins.
export const tracePropagationTargets = [
  /^\/(?!\/)/,
  /^https?:\/\/localhost(?::\d+)?(?:\/|$)/,
  /^https:\/\/(?:api\.zoe\.com|api\.joinzoe\.com|apik\.stage\.zoe\.net)(?:\/|$)/,
  /^https:\/\/public\.(?:prod|stage)\.zoe\.net(?:\/|$)/,
]
